import React from 'react';
import styled from 'styled-components';

export default function Example() {
    const Title = styled.h1`

    color: red;
    background: 

    `;

  return (
      <Title><h1>Example</h1></Title>
    
  )
}
